import React from "react";
import cx from "classnames";
import { MappingInfoIcon } from "./MappingIcons";
import INTERCOM_ARTICLES from "../../../constants/intercomArticles";

export const AMGEN = "Amgen";

// Shown for pharmacy, medical, and their encounter-submission counterparts
const AMGEN_WARNING_TYPES = ["pharmacy", "medical", "pharmacy_encounter", "medical_encounter"];

const ENCOUNTER_SUBMISSION_TYPES = ["pharmacy_encounter", "medical_encounter"];

const SUBMISSION_TYPE_LABELS = {
  pharmacy: "Pharmacy",
  medical: "Medical",
  pharmacy_encounter: "Pharmacy Encounter",
  medical_encounter: "Medical Encounter",
};

// Required-fields callout is keyed by claim type (pharmacy/medical), not by
// whether the submission is already going through the encounter module.
const REQUIRED_FIELDS_BY_CLAIM_TYPE = {
  pharmacy: "Prescriber ID, Payer BIN, and Payer PCN",
  medical: "Rendering Physician ID",
};

export const showAmgenWarning = (submissionType, submissions = []) =>
  AMGEN_WARNING_TYPES.includes(submissionType) && submissions.some((s) => s.hasAmgenNdc);

// stackText: Submission Summary tab shows a single stacked column; the
// Submission Data tab (default) splits the two text blocks into equal-width
// grid columns, plus a fixed-width CTA column.
const AmgenNotice = ({ submissionType, stackText = false }) => {
  const isEncounter = ENCOUNTER_SUBMISSION_TYPES.includes(submissionType);
  const claimType = submissionType.replace("_encounter", "");
  const typeLabel = SUBMISSION_TYPE_LABELS[submissionType];
  const claimTypeLabel = SUBMISSION_TYPE_LABELS[claimType];
  const requiredFields = REQUIRED_FIELDS_BY_CLAIM_TYPE[claimType];

  const textBlocks = isEncounter
    ? [
        `Beginning November 15, 2026, fields required for the claim submission are changing. ${claimTypeLabel} claims must include ${requiredFields}.`,
        "Please note, encounter data fields, now required, include: Billing Service Provider ID, Encounter Date of Service, Encounter Rendering Physician ID, Encounter HCPCS code, Encounter Diagnosis Code, and Encounter Place of Service Code.",
      ]
    : [
        <>
          Your submission contains NDCs for <span className="t--500">Amgen</span>.{" "}
          {`Beginning November 15, 2026, you will need to submit claims for Amgen through the ${typeLabel} Encounter Submissions module. In addition, fields required for the claim submission are changing. ${typeLabel} claims must include ${requiredFields}.`}
        </>,
        <>
          {`To submit through the ${typeLabel} Encounter Submissions module, navigate to `}
          <span className="t--500">{`Claims Data > ${typeLabel} Encounter Submissions`}</span>
          {`, or choose `}
          <span className="t--500">{`${typeLabel} Claims with Encounter Data`}</span>
          {` in the Start Submission modal.`}
        </>,
      ];

  return (
    <div className="submission_preview__notice mb--16">
      <MappingInfoIcon />
      <div className={cx("flex gap--16 flex-fill", { "flex--col": stackText })}>
        {stackText ? (
          textBlocks.map((block, index) => <div key={index}>{block}</div>)
        ) : (
          <div className="grid grid-cols-2 gap--16 flex-fill">
            {textBlocks.map((block, index) => (
              <div key={index}>{block}</div>
            ))}
          </div>
        )}
        <div
          className={cx(
            "flex",
            stackText ? "justify-content-end" : "submission_preview__notice__cta"
          )}
        >
          <a
            href={INTERCOM_ARTICLES.HOW_TO_SUBMIT_CLAIMS}
            className="button button--white button-lg"
            target="_blank"
          >
            Learn More
          </a>
        </div>
      </div>
    </div>
  );
};

export default AmgenNotice;
